
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface JUVCardProps {
  title?: string;
  icon?: LucideIcon;
  children: React.ReactNode;
  variant?: 'default' | 'glass' | 'luxury' | 'treatment';
  className?: string;
  glowEffect?: boolean;
}

const JUVCard = ({ 
  title, 
  icon: Icon, 
  children, 
  variant = 'default', 
  className,
  glowEffect = false 
}: JUVCardProps) => {
  const cardVariants = {
    default: 'bg-white border-juv-rose-clay/30 shadow-apple',
    glass: 'bg-white/95 border-juv-rose-clay/20 backdrop-blur-xl shadow-apple-lg',
    luxury: 'bg-gradient-to-br from-white to-juv-soft-blush/30 border-juv-terracotta/30 shadow-luxury',
    treatment: 'bg-juv-gradient-secondary border-juv-rose-clay/40 shadow-terracotta'
  };

  return (
    <Card 
      className={cn(
        'transition-all duration-300 hover:shadow-apple-xl hover:-translate-y-1',
        cardVariants[variant],
        glowEffect && 'hover:shadow-glow',
        className
      )}
    >
      {title && (
        <CardHeader className="pb-4">
          <CardTitle className="flex items-center gap-3 text-juv-deep-chestnut font-display">
            {Icon && <Icon className="h-5 w-5 text-juv-terracotta" />}
            {title}
          </CardTitle>
        </CardHeader>
      )}
      <CardContent className={title ? 'pt-0' : ''}>
        {children}
      </CardContent>
    </Card>
  );
};

export default JUVCard;
